module.exports = "<app-main-header></app-main-header>\n<app-pros></app-pros>\n<app-skills></app-skills>\n<app-development-process></app-development-process>\n<app-pros-full></app-pros-full>\n<app-contact-form-small></app-contact-form-small>\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/homepage/home-page.component.html
// module id = ../../../../../src/app/homepage/home-page.component.html
// module chunks = 0